export const documents = [
    // 📂 Documents d'état civil
    { nom: "Acte de naissance - futur époux", destinataire: "personne 1" },
    { nom: "Acte de naissance - future épouse", destinataire: "personne 2" },
    { nom: "Livret de famille des parents (si applicable)", destinataire: "commun" },

    // 📂 Documents d'identité et de domicile
    { nom: "Justificatif d'identité - futur époux", destinataire: "personne 1" },
    { nom: "Justificatif d'identité - future épouse", destinataire: "personne 2" },
    { nom: "Justificatif de domicile (facture ou attestation)", destinataire: "commun" },

    // 📂 Documents financiers et patrimoniaux
    { nom: "Titres de propriété des biens immobiliers personnels", destinataire: "commun" },
    { nom: "Contrats de prêt en cours", destinataire: "commun" },
    { nom: "Relevés de comptes bancaires et d'épargne", destinataire: "commun" },

    // 📂 Documents relatifs aux régimes matrimoniaux
    { nom: "Attestation de consentement mutuel au régime matrimonial", destinataire: "commun" },
    { nom: "Inventaire des biens personnels et communs", destinataire: "commun" },
    { nom: "Convention de séparation de biens (si applicable)", destinataire: "commun" },
    { nom: "Clause de participation aux acquêts (si applicable)", destinataire: "commun" },
    { nom: "Clause de communauté universelle (si applicable)", destinataire: "commun" },

    // 📂 Documents complémentaires (si demande spécifique)
    { nom: "Certificat de célibat (si applicable)", destinataire: "commun" },
    { nom: "Acte de divorce ou jugement de séparation (si applicable)", destinataire: "commun" },
    { nom: "Contrats de donation entre époux (si prévu)", destinataire: "commun" },

    // 📂 Documents pour les étrangers (si applicable)
    { nom: "Certificat de coutume", destinataire: "commun" },
    { nom: "Certificat de capacité matrimoniale", destinataire: "commun" }
];